export const NoClicktracksPlaceholder = () => {
  return (
    <div className="my-10 mb-6 flex justify-center ">
      <h1 className="max-w-md text-center text-xl opacity-50">
        You don&apos;t have any clicktracks made. Create a new one, or use a
        template! Once you do, they'll show up here.
      </h1>
    </div>
  );
};
